import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { HomeComponent } from './pages/home-page/home.component';
import { AboutComponent } from './pages/about-page/about.component';
import { ServicesComponent } from './pages/services-page/services.component';
import { ContactComponent } from './pages/contact-page/contact.component';
import { NotfoundPageComponent } from './pages/notfound-page/notfound-page.component';
import { DetailsPageComponent } from './pages/details-page/details-page.component';
import { PricingComponent } from './pages/pricing-page/pricing.component';
import { PolicyPageComponent } from './pages/policy-page/policy-page.component';
import { DashboardComponent } from './pages/dashboard/dashboard.component';
import { VersionComponentComponent } from './root-components/version-component/version-component.component';
import { AboutUsResolver } from './pages/about-page/resolvers/about-us.resolver';
import { DetailsPageResolver } from './pages/details-page/resolvers/detailsPageResolver';
import { HomeResolver } from './pages/home-page/resolvers/home.resolver';
import { ServiceResolver } from './pages/services-page/resolvers/services.resolver';
import { PricingResolver } from './pages/pricing-page/resolvers/pricing.resolver';

import { CourseComponent } from './pages/course/course.component';
import { ArticaleTableComponent } from './pages/articale-table/articale-table.component';
import { ArticleResolver } from './pages/articale-table/resolvers/articlePageResolver';
import { ProfilePageComponent } from './pages/profile-page/profile-page.component';
import { LoginComponent } from './pages/auth/login/login.component';
import { ForgetPasswordComponent } from './pages/auth/forget-password/forget-password.component';
import { OtpCodeComponent } from './pages/auth/otp-code/otp-code.component';
import { ResetPasswordComponent } from './pages/auth/reset-password/reset-password.component';
import { SignUpComponent } from './pages/auth/sign-up/sign-up.component';

import { EDetailsPageComponent } from './pages/e-details-page/e-details-page.component';
import { AuthGuard } from './pages/auth/services/auth/auth.guard';
import { CoursePageResolver } from './pages/course/resolvers/coursePageResolver';
import { PaymentGuard } from './pages/payment/services/payment/payment.guard';
import { RefundPolicyPageComponent } from './pages/refund-policy-page/refund-policy-page.component';
import { PaymentComponent } from './pages/payment/payment.component';
import { ProductsPageComponent } from './pages/products-page/products-page.component';
import { ProducteResolver } from './pages/products-page/resolvers/products.resolver';
const routes: Routes = [
  //...StaticContentRoutes,
  //...HeroRoutes,
  //...Marketing_ServicesRoutes,
  //...Software_ServicesRoutes,
  //...Teaching_ServicesRoutes,
  //...ArticlesRoutes,
  //...Our_ServicesRoutes,
  //...DictationRoutes,
  //...GrammarRoutes,
  //...Grammar_DictationRoutes,
  { path: '', redirectTo: 'en/home', pathMatch: 'full' },
  {
    path: ':lang/home',
    component: HomeComponent,
    resolve: { homeData: HomeResolver },
  },
  {
    path: ':lang/about',
    component: AboutComponent,
    resolve: { aboutData: AboutUsResolver },
  },
  {
    path: ':lang/services',
    component: ServicesComponent,
    resolve: { serviceData: ServiceResolver },
  },
  {
    path: ':lang/products',
    component: ProductsPageComponent,
    resolve: { serviceData: ProducteResolver },
  },
  { path: ':lang/contact', component: ContactComponent },
  { path: ':lang/policy', component: PolicyPageComponent },
  { path: ':lang/refund-policy', component: RefundPolicyPageComponent },
  { path: ':lang/details', component: DetailsPageComponent },
  {
    path: ':lang/details/:pagename/:filename/:title',
    component: DetailsPageComponent,
    resolve: { article: DetailsPageResolver },
  },
  {
    path: ':lang/pricing',
    component: PricingComponent,
    resolve: { pricingData: PricingResolver },
  },
  { path: ':lang/payment', component: PaymentComponent },
  { path: ':lang/dashboard', component: DashboardComponent },
  { path: 'version', component: VersionComponentComponent },
  {
    path: ':lang/course/:name',
    component: CourseComponent,
    resolve: { course: CoursePageResolver },
    canActivate: [AuthGuard, PaymentGuard],
  },
  {
    path: ':lang/course/:name/:video',
    component: CourseComponent,
    resolve: { course: CoursePageResolver },
    canActivate: [AuthGuard, PaymentGuard],
  },
  {
    path: ':lang/profile/:component',
    component: ProfilePageComponent,
    canActivate: [AuthGuard],
  },
  {
    path: ':lang/articaleTable',
    component: ArticaleTableComponent,
    resolve: { article: ArticleResolver },
  },
  { path: ':lang/e-details', component: EDetailsPageComponent },
  { path: ':lang/login', component: LoginComponent, canActivate: [AuthGuard] },
  {
    path: ':lang/signup',
    component: SignUpComponent,
    canActivate: [AuthGuard],
  },
  {
    path: ':lang/forgetPassword',
    component: ForgetPasswordComponent,
    canActivate: [AuthGuard],
  },
  {
    path: ':lang/resetPassword',
    component: ResetPasswordComponent,
    canActivate: [AuthGuard],
  },
  {
    path: ':lang/otpcode',
    component: OtpCodeComponent,
    canActivate: [AuthGuard],
  },

  { path: '**', component: NotfoundPageComponent },
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      scrollPositionRestoration: 'enabled',
      anchorScrolling: 'enabled',
      initialNavigation: 'enabledBlocking',
    }),
  ],
  exports: [RouterModule],
})
export class AppRoutingModule {}
